export default __webpack_public_path__ + "static/media/moffitt_small.c9357614.svg";